export default __webpack_public_path__ + "static/media/female-flatter.e9235bef.webp";